//常量配置
export default {
  UID: "uid",
  LANGS: "langs",
  KEYWORD: "keyword",
  FILECONTENT: 'file/loadEditSentTagPairFileByPage',
  TASKCONTENT: 'file/loadEditSentTagMyTask',
  TASKPROGRESS: 'fileTask/get_task_progress',
  FILEINFO: 'file/get',
  FILEPREVIEW: 'file/load_edit_file_tag',
  FILECHECK: 'file/checkQA',
  FILECHECKRESULT: '/file/getQAResult',
  ADDFRAGNENTMARKS: '/comment/insertCommentAllowRepeat',
  GETFRAGNENTMARKS: '/comment/queryByTransFileId',
  FILEREMARKS: '/comment/queryByTransFileId',
  FILEREUPDATETARGET: '/file/updateSingleSentence',
  MODIFYRECORD: '/file/queryByTransFileId',
  SENTTERMLIST: '/termSent/queryTransTermSentList',
  SENTMEMORYLIST: '/memory/findMemorySentSimilarSent',
  CURRENTREMARKSINFO: '/comment/queryBySentId',
  CURRENTREMARKSDELETE: '/comment/deleteBatch',
  CURRENTREMARKSUPDATE: '/comment/update',
  DICTTRANXLATE: '/dict/queryDictItemList',
  EDITORADDMEMORY: '/memorySent/editorAddMemorySent',
  AFRESHTRANSLATE: '/file/get_sent_machine_translation',
  MERGEFRANGMENT: '/sent/mergeTransTagSent',
  FRANGMENTSPLIT: '/sent/splitTransTagSent',
  TERMNUMBER: '/termSent/termSentNumberHint',
  TAGTARGET: '/file/getSentTagBySentId',
  LOGOUT: '/user/ajaxLogout',
  USERINFO: '/user/getUserInfo',
  UPDATE_TRANSLATION: '/file/update_sent_machine_translation',
  RESOURCE: '/resource/queryRes',
  AUTOMATIC: '/file/getSentTagAsync',
  FILETASKINFO: '/fileTask/getTaskDetail',
  CHANGECOMPANY: '/user/changeCompany',
  SUBMITTASK: 'fileTask/finishTask',
  GETROOT: '/user/getRootAdminId',
  UPDATESTATUS: '/sent/updateSentStatus',
  REMARKSTATE: '/sent/getRemarkStatusById',
  ADDTERMTAGTARGET: '/termSent/addTermSentUpdateTagTarget',
  SCHOOLTASKINFO: 'file/loadEditSentTagPairFileByPage',
  QACHECKLIST: '/transQa/queryFileSentQaByFileId',
  IGNOREQA: '/transQa/updateToIgnore',
  RECOVERYQA: '/transQa/updateToUnIgnore',
  PROJECTINFO: '/project/get_transProject',
  FILESENTQA: '/file/getTransFileSentQA',
  CombineTopfile: '/file/load_edit_combine_file',
  CombineLeftfile: '/file/load_edit_file',
  editorSentHighlight: 'file/editorSentHighlight',
  addTermSentUpdateTagTargetV2: '/termSent/addTermSentUpdateTagTargetV2',
  queryTemporaryPage: '/termSent/queryTemporaryPage',
  termSentUpdate: '/termSent/update',
  batchDeleteByIdList: '/termSent/batchDeleteByIdList',
  saveTemporaryTermLib: '/termSent/saveTemporaryTermLib',
  updateFinish: '/taskScore/updateFinish',
  queryTaskScoreAndEval: '/taskScore/queryTaskScoreAndEval',
  insertTaskManualScore: '/taskScore/insertTaskManualScore',
  getMachineTranslation: '/file/getMachineTranslation',
  countTargetSentIsNull: '/fileTask/countTargetSentIsNull',
  QUERYROLLBACKTASK: '/fileTask/queryRollBackTask',
  ROLLBACKTASKTOSENT: '/fileTask/rollBackTaskToSent',
  ROLLBACKTASK: '/fileTask/rollBackTask',
  ACCEPTANCETASK: '/fileTask/acceptanceTask',
  UPDATEBATCHSENTENCE: "/file/updateBatchSentence",
  ADDCUSTOMDOMAIN: '/project/addCustomDomain',
  queryUserRoleResource: '/resource/queryUserRoleResource',
  DEBLOCKING:'/file/debLocking',
  DEBLOCKALL:'/file/debLockAll',
  CANCELCONFIRMATION:'/sent/cancelConfirmation'
};